import _ from 'lodash';
import * as ElementApi from './ElementApi';
import ElementConstants from './ElementConstants';
import { v4 as uuidv4 } from 'uuid';

const receivedElement = (element) => ({
    type: ElementConstants.ELEMENT_RECEIVED,
    payload: {
        id: element.id,
        slide_id: element.slide_id,
        element_type: element.type,
        x: element.x,
        y: element.y,
        width: element.width,
        height: element.height,
        position: element.position,
        data: element.data,
    }
});

export const elementChanging = (elementId, changes) => ({
    type: ElementConstants.ELEMENT_CHANGING,
    payload: {
        id: elementId,
        changes: changes,
    }
});

export const elementRemoved = (elementId) => ({
    type: ElementConstants.ELEMENT_REMOVED,
    payload: {
        id: elementId,
    }
});

export const elementSentBackward = (elementId) => ({
    type: ElementConstants.ELEMENT_SENT_BACKWARD,
    payload: {
        id: elementId,
    }
});

export const elementBroughtForward = (elementId) => ({
    type: ElementConstants.ELEMENT_BROUGHT_FORWARD,
    payload: {
        id: elementId,
    }
});

export const elementSentToBack = (elementId) => ({
    type: ElementConstants.ELEMENT_SENT_TO_BACK,
    payload: {
        id: elementId,
    }
});

export const elementBroughtToFront = (elementId) => ({
    type: ElementConstants.ELEMENT_BROUGHT_TO_FRONT,
    payload: {
        id: elementId,
    }
});


// ---


export const receivedElements = (elements) => (dispatch) => {
    _.map(elements, element => {
        dispatch(receivedElement(element))
    });
};

export function listElements(slideId) {
    return function (dispatch) {
        return ElementApi.listElements(slideId).then(response => {
            _.map(response, element => {
                dispatch(receivedElement(element))
            });

            return response;
        });
    };
}

export function fetchElement(elementId) {
    return function (dispatch) {
        return ElementApi.fetchElement(elementId).then(element => {
            dispatch(receivedElement(element));
        });
    };
}

export function createElement(slideId, type) {
    return function (dispatch) {
        return ElementApi.createElement(slideId, type).then(() => {
            dispatch(listElements(slideId));
        });
    }
}

export function addTextElement(storyId, slideId) {
    const id = uuidv4();
    return function (dispatch) {
        return ElementApi.addTextElement(storyId, slideId, id)
            .then(() => dispatch(listElements(slideId)))
            .then(() => id);
    }
}

export function addImageElement(storyId, slideId) {
    const id = uuidv4();
    return function (dispatch) {
        return ElementApi.addImageElement(storyId, slideId, id)
            .then(() => dispatch(listElements(slideId)))
            .then(() => id);
    }
}

export function elementChanged(elementId) {
    return function (dispatch, getState) {
        const element = getState().elements[elementId];

        if (! element) {
            return;
        }

        return ElementApi.updateElement(
            elementId,
            element.x,
            element.y,
            element.width,
            element.height,
            JSON.stringify(element.data)
        );
    }
}

export function removeElement(elementId) {
    return function (dispatch) {
        dispatch(elementRemoved(elementId));
        return ElementApi.removeElement(elementId).then(() => {
        });
    }
}

export function bringElementForward(elementId) {
    return function (dispatch) {
        dispatch(elementBroughtForward(elementId));
        return ElementApi.bringForward(elementId).then(() => {
        });
    }
}

export function sendElementBackward(elementId) {
    return function (dispatch) {
        dispatch(elementSentBackward(elementId));
        return ElementApi.sendBackward(elementId).then(() => {
        });
    }
}

export function bringElementToFront(elementId) {
    return function (dispatch) {
        dispatch(elementBroughtToFront(elementId));
        return ElementApi.bringForward(elementId).then(() => {
        });
    }
}

export function sendElementToBack(elementId) {
    return function (dispatch) {
        dispatch(elementSentToBack(elementId));
        return ElementApi.sendToBack(elementId).then(() => {
        });
    }
}